<template>
  <filtertron-tray-section
    v-if="sponsorsEnabled && category.createdAt"
    id="category-configurator-images"
    :title="lang.get('category.configuration.images.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div class="form-group">
        <label>
          {{ lang.get('category.form.image_heading.label') }}
        </label>
        <multilingual
          :supported-languages="supportedLanguages"
          :resource="category"
          property="image_heading"
          @input="handleHeadingInput"
        />
      </div>
      <div class="form-group">
        <label>{{ lang.get('category.form.max_image_width.label') }}</label>
        <input
          type="text"
          :value="category.maxImageWidth"
          class="form-control"
          @input="e => handleInput('maxImageWidth', toInt(e.target.value))"
        />
      </div>
      <uploader
        v-if="category.uploaderOptions"
        :files="category.files"
        :options="category.uploaderOptions.clarify()"
        :button-label="lang.get('files.buttons.images')"
        @deleted="deleteFile"
        @completed="reloadCategory"
      />
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import Multilingual from '@/lib/components/Translations/Multilingual';
import Uploader from '@/lib/components/Uploader/Uploader';
import handleInputMixin from '../handle-input-mixin.js';
import handleTranslatedInputMixin from '../handle-translated-input-mixin.js';
import toIntMixin from '../to-int-mixin.js';

const toastr = require('toastr');

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection,
    Multilingual,
    Uploader
  },
  mixins: [handleInputMixin, handleTranslatedInputMixin, toIntMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['sponsorsEnabled'])
  },
  methods: {
    ...mapMutations('entryForm', ['replaceCategoryFiles']),
    deleteCategoryImageUrl(fileId) {
      return '/category/' + this.category.slug + '/image/' + fileId;
    },
    reloadCategoryUrl() {
      return '/entry-form/manager/categories/' + this.category.slug;
    },
    deleteFile(id, remoteId) {
      if (remoteId) {
        this.$http.delete(this.deleteCategoryImageUrl(remoteId)).then(
          () => {
            this.reloadCategory();
          },
          () => {
            toastr.error(this.lang.get('miscellaneous.alerts.generic'));
          }
        );
      }
    },
    reloadCategory() {
      // After the category images are uploaded (and processed) it's
      // necessary to reload the category's files, so that the sponsor logos
      // get refreshed on the entry form.
      this.$http.get(this.reloadCategoryUrl()).then(
        response => {
          if (response && response.status === 200) {
            this.replaceCategoryFiles({
              oldCategory: this.category,
              newCategory: response.data.category
            });
          }
        },
        () => {
          toastr.error(this.lang.get('miscellaneous.alerts.generic'));
        }
      );
    },
    handleHeadingInput(translated) {
      const heading =
        (translated[this.lang.locale] || {})['image_heading'] || '';

      this.$emit('input', {
        translated: translated,
        heading: heading
      });
    }
  }
};
</script>
